import React, {FC} from "react"

import {FormattedMessage, injectIntl, InjectIntl} from "@irati/utils/lang"
import Flex from "@irati/ui/src/Flex"
import {WellnessMediaType} from "@irati/types"
import {formatFromTimeToHoursAndMinutes} from "@irati/wellness/utils"
import mainTheme from "@irati/ui/src/global/theme"
import {RightBadge} from "@irati/ui/src/Badge"

import DetailsPill from "./DetailsPill"

interface Props extends InjectIntl {
  duration: string,
  type: string,
  mediaCount?: number,
  isPremium?: boolean
}

const TopDetails: FC<Props> = ({duration, type, mediaCount = 1, isPremium, formatMessage}) => {
  const videoCountText = formatMessage({id: "wellness.videoCard.videoCountText"}, {count: mediaCount})

  return (
    <Flex justifyContent="space-between" alignItems="center">
      {type === WellnessMediaType.VideoCourse || (type === WellnessMediaType.AudioCourse && <DetailsPill text={videoCountText} />)}
      <DetailsPill text={formatFromTimeToHoursAndMinutes(duration)} type={type} />
      {isPremium &&
      <RightBadge color={mainTheme.colors.primary1} uppercase>
        <FormattedMessage id="wellness.rentalMedia.premium" />
      </RightBadge>
      }
    </Flex>
  )
}

export default injectIntl(TopDetails)
